import { render } from "./QuizInfoEditor.vue?vue&type=template&id=1853079f&scoped=true"
import script from "./QuizInfoEditor.vue?vue&type=script&lang=js"
export * from "./QuizInfoEditor.vue?vue&type=script&lang=js"

import "./QuizInfoEditor.vue?vue&type=style&index=0&id=1853079f&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1853079f"]])

export default __exports__